<template>
  <div>
    <div v-if="err" class="my-5 text-center bolder red-text" v-html="$linebreak(err)"></div>
    <step-01 v-else @next="onNext"/>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Step01 from './join/Step01.vue'
export default {
  name: 'JoinPage',
  components: { Step01 },
  data: () => ({
    err: '준비 중 입니다.',
    step: 2,
    org: ''
  }),
  computed: {
    // org () {
    //   return this.$route.params.org
    // }
  },
  methods: {
    ...mapMutations('auth', ['setOrg']),
    onNext () {
      this.$router.push({ name: 'JoinPhoneAuth', params: { org: this.org } })
    },
    async load () {
      this.org = this.$route.path.substr(1)
      const org = await this.$Org.get({ prefix: this.org })
      if (!org) {
        this.err = '가입 기관명이 올바르지 않습니다.\nurl의 가입 기관명을 확을 하세요.'
      } else {
        this.err = ''
      }
    }
  },
  watch: { org () { this.load() } },
  created () { this.load() }
}
</script>
